import { connect } from 'react-redux';
import { selectIsDeviceTypeDesktop } from 'selectors/device';
import Markdown from '@sp/ui/v2/base/Markdown';

const mapStateToProps = (state) => ({
  isDesktop: selectIsDeviceTypeDesktop(state),
});

export default connect(mapStateToProps)(Markdown);
